import styled from 'styled-components';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { richBlack_2 } from '@paradigm/design-system/src/colors';
import {
  selectIsFirmDisabledLeaderboardAnonymity,
  updateUserPermissionsAction,
} from '@paradigm/store/auth';
import { exceptionLogger } from '@paradigm/logging/src/logging';
import { updateFirmLeaderboardAnonymity } from '@paradigm/features/src/leaderboard/repositories/preferences';

import toast from '#/components/toasts/toast';
import Toggle from '@paradigm/design-system/src/components/Toggle';
import Tooltip from '@paradigm/design-system/src/components/Tooltip';

export default function GoPublicSwitch() {
  const dispatch = useDispatch();
  const isFirmDisabledLeaderboardAnonymity = useSelector(
    selectIsFirmDisabledLeaderboardAnonymity,
  );
  const [isPublic, setIsPublic] = useState(isFirmDisabledLeaderboardAnonymity);

  const toggle = () => {
    updateFirmLeaderboardAnonymity(!isPublic)
      .then((resp) => {
        if (resp.ok) {
          dispatch(
            updateUserPermissionsAction({
              firm_disabled_leaderboard_anonymity: !isPublic,
            }),
          );
          setIsPublic(!isPublic);
        } else {
          toast('Failed to update leaderboard public visibility.');
        }
      })
      .catch(exceptionLogger('Unable to update Firm Leaderboard Anonymity'));
  };

  return (
    <Container>
      <Toggle
        ariaLabel="go public"
        checked={isPublic}
        onChange={toggle}
        name="go-public-switch"
        label="Go Public"
      />

      <Tooltip
        id="go-public-switch"
        showIconInPopover={false}
        css="margin-left: 4px"
        tooltipContent="Your Firm name will be displayed to everyone in Volumes Tab."
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  height: 30px;
  margin-right: 20px;
  border-radius: 7px;
  background-color: ${richBlack_2};
  padding: 0 13px;
  i {
    margin-top: 6px;
  }
  label {
    opacity: 0.9;
    font-size: 0.8rem;
    font-weight: 500;
    letter-spacing: 0;
  }
`;
